import Stomp from 'webstomp-client';
import SockJS from 'sockjs-client';
import vueAuth from '@common/lib/auth';
import {
  mapActions as commonMapActions,
  mapState as commonMapState,
  mapGetters as commonMapGetters,
} from '@common/store/modules/common';
import * as commonActions from '@common/store/modules/common/types';
import * as commonGetters from '@common/store/modules/common/getters';
import { authMapGetters, authGetters } from '@common/store/modules';
import {
  mapActions as userMapActions,
  mapState as userMapState,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';
import {
  mapActions as chatMapActions,
  mapState as chatMapState,
  mapGetters as chatMapGetters,
} from '@common/store/modules/chat';
import * as chatActions from '@common/store/modules/chat/types';
import * as chatGetters from '@common/store/modules/chat/getters';
import InfiniteLoading from 'vue-infinite-loading';
import ChatRoomMessageItem from './components/ChatRoomMessageItem.vue';
import AttachmentModal from './modal/AttachmentModal';
import ImageModal from './modal/ImageModal';
import ImageViewModal from './modal/ImageViewModal';

import {
  sleep,
  connectedSocket,
  closeSocket,
  checkMobileOperatingSystem,
  setCallbackOnClickBackKey,
  nativeEnableBackKey,
  nativeDisableBackKey,
  jsonEscape,
  toBR,
  nativeBrowse,
  isApp,
} from '@common/lib/common/utils';
export default {
  components: {
    InfiniteLoading,
    ChatRoomMessageItem,
    AttachmentModal,
    ImageModal,
    ImageViewModal,
  },
  data: {
    isCreateMode: false,
    isChatBtn: false, // 상담시간 체크
    isChatBtnView: false, // 상담시간 체크 버튼 노출
    uuid: null,
    storeId: null,
    fetchCompleted: false,
    resendMessage: null,
    message: '',
    messages: [],
    messageIdx: 0,
    lastReadMessageIdx: 0,
    connectMessageIdx: 0,
    socket: null,
    stompClient: null,
    subscription: null,
    direction: 'top',
    infiniteId: 0,
    size: 20,
    first: true,
    toast: null,
    actived: false,
    isSocketStatusToast: true,
    pingId: null,
    isWatchMode: true,
    imageUrl: '',
    isImageModalOpen: false,
    isImageViewModalOpen: false,
    imageViewUrl: '',
    imageViewTitle: '',
    imageData: [
      {
        title: 'KT TV 채널',
        type: 'tvChannel',
        url: 'internet_commerce/img_tv_channel.png',
      },
      {
        title: '인터넷 설치비 안내',
        type: 'internetInstallCost',
        url: 'internet_commerce/img_internet_install_cost.png',
      },
    ],
  },
  computed: {
    ...authMapGetters({
      currentUser: authGetters.CURRENT_USER,
    }),
    ...chatMapGetters({
      chatrooms_with: chatGetters.CHATROOMS_WITH,
      chatroom_watch: chatGetters.CHATROOM_WATCH,
      chatrooms: chatGetters.CHATROOMS,
      chatroom: chatGetters.CHATROOM,
      chatmessages: chatGetters.CHATMESSAGES,
      postProcessing: chatGetters.POST_PROCESSING,
    }),
  },
  async beforeRouteEnter(to, from, next) {
    //console.log('beforeRouteEnter');
    //await store.dispatch('chat/CHATMESSAGES_RESET_STATE');
    return next(async vm => {
      vm.init();
      await vm.initFetch();
      vm.initNetworkEvents();
      //console.log('start');
      await vm.connectToWebsocket();
      //console.log('end');
      vm.handleForeground();
      setCallbackOnClickBackKey(vm.handleOnClickBackKey);
      vm.handleStartChatPing();
      vm.handleStartChatWatch();
      vm.localMessage();
    });
  },
  beforeDestroy(vm) {
    //console.log('beforeDestory');
    vm.disconnect();
    vm.clearNetworkEvents();
    vm.handleBackground();
    closeSocket();
    setCallbackOnClickBackKey();
    if (vm.pingId !== null) {
      clearTimeout(vm.pingId);
    }
  },
  methods: {
    ...commonMapActions([commonActions.SET_DIALOG, commonActions.HIDE_DIALOG]),
    ...chatMapActions([
      chatActions.CHATMESSAGES_RESET_STATE,
      chatActions.CHATROOM_RESET_STATE,
      chatActions.CHATROOMS_RESET_STATE,
      chatActions.FETCH_CHATROOM_WITH_STORE,
      chatActions.FETCH_CHATROOMS,
      chatActions.FETCH_CHATROOM,
      chatActions.SYNC_CHATROOM,
      chatActions.CREATE_CHATROOM,
      chatActions.SET_CHATMESSAGES_BY_MESSAGE_IDX,
      chatActions.GET_CHATMESSAGES,
      //chatActions.GET_CHATMESSAGES2,
      chatActions.RECEIVE_CHATMESSAGE,
      chatActions.UPLOAD_FILE,
      chatActions.SET_POST_PROCESSING,
      chatActions.UPDATE_MEMBER_SCREEN_ACTIVED,
      chatActions.FETCH_CHATROOM_WATCH,
      // chatActions.FETCH_CHATROOM_CHECK_LIMIT,
      chatActions.REPORT_CHAT,
    ]),
    handleChangeMessage(e) {
      this.message = e.target.value;
    },
    init() {
      this.isCreateMode = false;
      this.uuid = this.$route.params.uuid;
      this.storeId = this.$route.params.storeId;
      this.messages = [];
      this[chatActions.CHATMESSAGES_RESET_STATE]();
      this[chatActions.CHATROOM_RESET_STATE]();
      this[chatActions.CHATROOMS_RESET_STATE]();
      this.isCreateMode = this.storeId ? true : false;
      if (!this.isCreateMode) {
        this.setLastReadMessageIdx();
      }
    },
    localMessage() {
      // 임시저장한 채팅내용 가져오기
      this.message = localStorage.getItem(`chatroom-input-${this.uuid}`);

      if (this.message) {
        const valueLength = this.message.length;
        const valueArr = this.message.split('\n');
        const valueArrCnt = valueArr.length;
        console.log('valueLength = ' + valueLength);
        console.log('valueArrCnt = ' + valueArrCnt);
        if (valueArrCnt >= 2 || valueLength > 18) {
          this.$refs.textbox.style.height = '8rem';
          this.$refs.chat_write_wrap.style.height = 'auto';
        }
      }
    },
    setLastReadMessageIdx() {
      let storageData = localStorage.getItem(`perce-chatroom-${this.uuid}`);
      if (storageData != null) {
        storageData = JSON.parse(storageData);
        const storageMessageIdx = storageData.messageIdx;
        this.lastReadMessageIdx = storageMessageIdx;
      }
    },
    setConnectMessageIdx(messageIdx) {
      this.connectMessageIdx = messageIdx;
    },
    async syncChatRoom() {
      await this[chatActions.SYNC_CHATROOM]({
        uuid: this.uuid,
      });
    },
    async getChatMessages(params) {
      const { startIdx, listMinIdx } = params;
      await this[chatActions.GET_CHATMESSAGES]({
        chatRoomType: this.chatRoomType,
        uuid: this.uuid,
        messageIdx: this.messageIdx,
        startIdx,
        listMinIdx,
        size: this.size,
      });
      this.messages = this.chatmessages;

      // this.messages = this.messages.replace('<', '&lt;');
      // this.messages = this.messages.replace('>', '&gt;');

      console.log('messagesmessagesmessagesmessagesmessagesmessagesmessages');
      console.log(this.messages);
    },

    async infiniteHandler($state) {
      if (this.infiniteId == 0) {
        $state.complete();
      } else {
        let startIdx = undefined;
        let listMinIdx = undefined;
        //console.log(this.chatmessages);
        if (this.chatmessages.length > 0) {
          listMinIdx = this.chatmessages[0][0].messageIdx;
          startIdx = Math.max(
            this.chatmessages[0][0].messageIdx - this.size,
            1,
          );
        }
        //console.log('startIdx', startIdx, 'listMinIdx', listMinIdx);
        // if (!this.first) await sleep(1000);
        await this.getChatMessages({
          messageIdx: this.messageIdx,
          startIdx,
          listMinIdx,
        });

        if (this.first) {
          this.first = false;
          /*setTimeout(() => {
            this.scrollToBottom(true);
          }, 1);*/
          this.handleFirstLoaded();
        }

        if (this.chatmessages.length > 0) {
          if (this.chatmessages[0][0].messageIdx <= 0.1) {
            $state.complete();
          } else {
            $state.loaded();
          }
        } else {
          $state.complete();
        }
      }

      //$state.loaded();
      //$state.complete();
    },
    scrollToBottom(isNotAnimate) {
      const el = this.$refs.dummy;
      if (el) {
        el.scrollIntoView({ behavior: isNotAnimate ? 'auto' : 'smooth' });
      }
    },
    handleFocusTextbox() {
      const ts = checkMobileOperatingSystem() === 'iOS--' ? 50 : 200;
      setTimeout(() => {
        this.scrollToBottom(true);
        if (checkMobileOperatingSystem() !== 'iOS--') {
          setTimeout(() => {
            this.scrollToBottom(true);
          }, 50);
        }
      }, ts);
    },
    handleFirstLoaded() {
      const ts = checkMobileOperatingSystem() === 'iOS--' ? 50 : 200;
      this.scrollToBottom(true);
      setTimeout(() => {
        this.scrollToBottom(true);
        if (checkMobileOperatingSystem() !== 'iOS--') {
          setTimeout(() => {
            this.scrollToBottom(true);
            if (checkMobileOperatingSystem() !== 'iOS--') {
              setTimeout(() => {
                this.scrollToBottom(true);
              }, 200);
            }
          }, 50);
        }
      }, ts);
    },
    viewToast(msg, duration) {
      if (!this.isSocketStatusToast) return;
      this.toast = this.$toasted.show(msg, {
        //theme: "outline",
        position: 'top-center',
        duration: duration || 2000,
        //conatinerClass: 'toasted-container-chat',
      });
    },
    viewToastAndHide(msg) {
      if (!this.isSocketStatusToast) return;
      this.toast.text(msg).goAway(2000);
    },
    hideToast() {
      if (!this.isSocketStatusToast) return;
      this.$toasted.clear();
    },
    getHeader() {
      const headers = {};
      headers[vueAuth.getTokenHeader()] = vueAuth.getTokenValue();
      return headers;
    },
    initNetworkEvents() {
      window.addEventListener('offline', this.triggerOffline);
      window.addEventListener('online', this.triggerOffline);
    },
    clearNetworkEvents() {
      window.removeEventListener('offline', this.triggerOffline);
      window.removeEventListener('online', this.triggerOnline);
    },
    triggerOffline() {
      this.triggerReconnect('offline');
    },
    triggerOnline() {
      this.triggerReconnect('online');
    },
    triggerReconnect(eventName) {
      console.log(eventName, 'event received');

      // This will trigger the "onWebSocketClose" method in stompClient
      this.socket.close();
    },
    //소켓 연결
    async connectToWebsocket() {
      if (!this.uuid) return;
      connectedSocket(this.handleForeground, this.handleBackground);
      const serverURL = process.env.VUE_APP_WEBSOCKET_URL;
      this.socket = new SockJS(serverURL);
      this.stompClient = Stomp.over(this.socket);
      // Switch off debug
      this.stompClient.debug = () => {};
      // Error handlers. There are many other methods also
      this.stompClient.onDisconnect = () => {
        this.reConnectWebSocket();
      };
      this.stompClient.onStompError = () => {
        this.reConnectWebSocket();
      };
      // This is the most important
      this.stompClient.onWebSocketClose = () => {
        this.reConnectWebSocket();
      };

      //this.viewToast('접속중입니다.', 0);
      return new Promise((resolve, reject) => {
        const headers = this.getHeader();
        this.stompClient.connect(
          headers,
          async frame => {
            // 소켓 연결 성공
            this.connected = true;
            //this.viewToast('접속되었습니다.');
            //this.viewToastAndHide('접속되었습니다.');
            //메시지 다시 받기.
            await this.handleLatelyMessage();
            //이전페이지에서 처리된 것들 사후처리
            await this.handlePostProcessing();

            this.handleForeground();
            //채팅방 sub
            this.subscription = this.stompClient.subscribe(
              '/sub/chat/room/' + this.uuid,
              async message => {
                console.log('구독으로 받은 메시지 입니다.', message.body);
                const data = JSON.parse(jsonEscape(message.body));
                this.subscribeMessage(data, resolve);
              },
            );
            //this.$refs.chat_room_wrap.style.visibility = 'visible';
          },
          error => {
            // 소켓 연결 실패
            //console.log('소켓 연결 실패', error);
            this.viewToastAndHide('접속실패하였습니다.');
            this.connected = false;
            this.reConnectWebSocket();
            resolve(false);
          },
        );
      });
    },
    reConnectWebSocket(ts = 5) {
      if (!this.actived) return;
      const _this = this;
      const retryTimeout = ts || 5;
      this.connected = false;
      console.log(
        'Re-connecting websocket after',
        retryTimeout * 1000,
        'secs...',
      );
      // Call the websocket connect method
      setTimeout(function() {
        _this.connectToWebsocket();
      }, retryTimeout * 1000);
    },
    async disconnect() {
      const headers = this.getHeader();
      if (this.stompClient && this.stompClient.connected) {
        if (this.subscription != null) {
          this.subscription.unsubscribe();
        }
        this.stompClient.disconnect(() => {
          console.log('소켓 연결 해제');
        }, headers);
      }
    },
    sendMessage: function(type, params) {
      // alert(type);
      const headers = this.getHeader();
      // alert(11);
      this.resendMessage = { type, params };
      // alert(12);
      if (this.stompClient && this.stompClient.connected) {
        // alert(13);
        let message = {};
        if (type === 'TEXT') {
          message.text = this.message;
          this.$nextTick(function() {
            this.$refs.textbox.focus();
          });
        } else if (type === 'IMAGE') {
          message.image = params.file.fileUrl;
        } else if (type === 'ESTIMATE') {
          message.estimateId = params.estimateId;
          message.sendView = 'chatroom';
        } else if (type === 'QUOTATION') {
          message.quotation = params.quotation;
        } else if (type === 'SYSTEM') {
          message = params;
        }

        this.stompClient.send(
          '/pub/chat/message',
          JSON.stringify({
            type: type,
            uuid: this.uuid,
            message: JSON.stringify(message),
          }),
          headers,
        );
        this.message = '';
      } else {
        // alert(14);
        if (this.chatRoomType === 'OneOnOne') {
          this.connectToWebsocket();
          // alert(15);
        } else {
          this.createChatRoom();
          // alert(16);
        }
      }

      console.log('this.isChatBtn');
      console.log(this.isChatBtn);
      console.log(this.isChatBtnView);
      console.log(type);

      if (!this.isChatBtn && this.isChatBtnView) {
        console.log(type);
      } else {
        // 전송시 채팅 입력창 사이즈 원복
        this.$refs.textbox.style.height = '4rem';
        // this.$refs.chat_write_wrap.style.height = '5.4rem';
      }

      let storageInputData = localStorage.getItem(
        `chatroom-input-${this.uuid}`,
      );
      if (storageInputData != null) {
        // 전송시 채팅 입력창에 저장된 내용 삭제
        localStorage.removeItem(`chatroom-input-${this.uuid}`);
      }
    },
    subscribeMessage: async function(data, resolve) {
      if (
        data.type !== 'CONNECT' &&
        data.type !== 'DISCONNECT' &&
        data.type !== 'READ'
      ) {
        this.messageIdx = data.messageIdx;
        await this[chatActions.RECEIVE_CHATMESSAGE]({
          chatRoomType: this.chatRoomType,
          uuid: this.chatroom.uuid,
          messageIdx: data.messageIdx,
          messages: [data],
          append: true,
        });
        this.messages = null;
        this.messages = this.chatmessages;
        //페이지 하단으로.
        setTimeout(() => {
          this.scrollToBottom();
        }, 500);
        if (data.type === 'TEXT') {
          // ios
          // setTimeout(() => {
          //   this.$refs.textbox.focus();
          // }, 1000);
        }

        if (data.type === 'EXIT') {
          // alert(1);
          let storageInputData = localStorage.getItem(
            `chatroom-input-${this.chatroom.uuid}`,
          );
          if (storageInputData != null) {
            //localStorage 삭제
            localStorage.removeItem(`chatroom-input-${this.chatroom.uuid}`);
          }
          localStorage.removeItem(`perce-chatroom-${this.chatroom.uuid}`);

          // alert(data.userId);
          // alert(this.currentUser.id);

          if (data.userId === this.currentUser.id) {
            // alert(2);
            this.$router.go(-1);
            return;
          }
          this[commonActions.SET_DIALOG]({
            type: 'confirm',
            icon: 'warning',
            //title: this.$t('common.confirm'),
            message: '상대방이 채팅을 종료했습니다.',
            okCb: async () => {
              this.$router.go(-1);
            },
          });
        }
        //읽음
        this.sendReadMessageIdx(data.messageIdx);
      } else if (data.type === 'CONNECT') {
        //본인이 연결되면 screenon send
        if (data.userId === this.currentUser.id) {
          console.log('본인연결');
          this.handleForeground();

          // messageIdx비교
          let currentMessageIdx = this.messageIdx;
          const dataMessageIdx = data.messageIdx;
          if (this.connectMessageIdx === 0) {
            this.setConnectMessageIdx(dataMessageIdx);
          }
          if (dataMessageIdx != currentMessageIdx) {
            this.setLastReadMessageIdx();
            this.setConnectMessageIdx(dataMessageIdx);
            let startIdx = currentMessageIdx + 1;
            let loop = 0;
            do {
              if (loop > 0) currentMessageIdx = startIdx + 20 - 1;
              startIdx = currentMessageIdx + 1;
              //if (dataMessageIdx - currentMessageIdx + 1 > 20)
              //  startIdx = dataMessageIdx - 20 + 1;

              //console.log('====startIdx ', startIdx);
              await this.getChatMessages({
                messageIdx: dataMessageIdx,
                startIdx: startIdx,
                append: true,
              });

              loop++;
            } while (startIdx + 20 - 1 <= dataMessageIdx);

            this.messages = null;
            this.messages = this.chatmessages;
          }
          this.sendReadMessageIdx(data.messageIdx);
          if (resolve) {
            resolve(true);
          }
        }
      }
    },
    recvMessage: function(recv) {
      this.userCount = recv.userCount;
      this.messages.unshift({
        type: recv.type,
        sender: recv.sender,
        message: recv.message,
      });
    },
    sendReadMessageIdx(messageIdx) {
      const headers = this.getHeader();
      if (this.stompClient && this.stompClient.connected) {
        this.stompClient.send(
          '/pub/chat/read',
          JSON.stringify({
            uuid: this.uuid,
            chatRoomId: this.chatroom.id,
            messageIdx: messageIdx,
          }),
          headers,
        );
      } else {
        this.connectToWebsocket();
      }
    },
    async handlePostProcessing() {},
    async handleLatelyMessage() {},
    exitChatroom() {
      this.isWatchMode = false;
      if (this.isCreateMode) {
        this.$router.go(-1);
        return;
      }
      this[commonActions.SET_DIALOG]({
        type: 'confirm',
        icon: 'warning',
        //title: this.$t('common.confirm'),
        message: '채팅방에서 나가시겠습니까?',
        okCb: async () => {
          this.sendMessage('SYSTEM', {
            text: '상대방이 대화를 종료하였습니다.',
          });
          // this.$router.go(-1);
          this.sendMessage('EXIT');
        },
      });
    },
    handleStartChatPing() {
      if (this.pingId === null) {
        this.pingId = setTimeout(() => {
          this.handleChatPing();
        }, 1000 * 10);
      }
    },
    handleStartChatWatch() {
      console.log('isWatchMode');
      console.log(this.isWatchMode);
      if (this.stompClient && this.stompClient.connected && this.actived) {
        // if (!this.isWatchMode) return;
        this[chatActions.FETCH_CHATROOM_WATCH]({
          chatRoomId: this.chatroom.id,
        }).then(() => {
          console.log('chatroom_watch');
          console.log(this.chatroom_watch);
        });
      }
    },
    handleChatPing() {
      this.pingId = null;
      const headers = this.getHeader();
      if (this.stompClient && this.stompClient.connected && this.actived) {
        this.stompClient.send(
          '/pub/chat/ping',
          JSON.stringify({
            uuid: this.uuid,
            chatRoomId: this.chatroom.id,
          }),
          headers,
        );
        this.handleStartChatWatch();
      }
      this.handleStartChatPing();
    },
    handleForeground() {
      if (this.actived) return;
      this.actived = true;
      this[chatActions.UPDATE_MEMBER_SCREEN_ACTIVED]({
        chatRoomId: this.chatroom.id,
        actived: true,
      });
      if (!this.connected) {
        this.reConnectWebSocket(0.1);
      }
    },
    handleBackground() {
      if (!this.actived) return;
      this.actived = false;
      this[chatActions.UPDATE_MEMBER_SCREEN_ACTIVED]({
        chatRoomId: this.chatroom.id,
        actived: false,
      });
    },
    handleOnClickBackKey() {
      this.closeAttachmentModal();
      this.closeImageModal();
    },
    openAttachmentModal() {
      if (this.isCreateMode) return;
      this.$refs.attachmentModal.isOpen = true;
      nativeDisableBackKey();
    },
    closeAttachmentModal() {
      this.$refs.attachmentModal.isOpen = false;
      nativeEnableBackKey();
    },
    //파일 업로드
    async handleImageChange(file) {
      //console.log(file);
      const data = await this[chatActions.UPLOAD_FILE]({
        uuid: this.uuid,
        file: file.blob,
      });
      //console.log(data);
      this.sendMessage('IMAGE', { file: data });
    },
    openImageModal(url) {
      this.imageUrl = url;
      this.isImageModalOpen = true;
      nativeDisableBackKey();
    },
    closeImageModal() {
      this.isImageModalOpen = false;
      nativeEnableBackKey();
    },
    openSelfIdenModal(url) {
      if (isApp()) {
        nativeBrowse(url);
      } else {
        window.open(url, '_blank');
      }
    },
    openImageViewModal(type) {
      const foundData = this.imageData.find(data => data.type === type);
      console.log('foundData');
      console.log(foundData);

      this.imageViewUrl = foundData.url;
      this.imageViewTitle = foundData.title;

      this.isImageViewModalOpen = true;
      nativeDisableBackKey();
    },
    closeImageViewModal() {
      this.isImageViewModalOpen = false;
      nativeEnableBackKey();
    },
    handleImageLoaded(message) {
      if (message.messageIdx >= this.messageIdx - this.size / 2) {
        this.scrollToBottom(true);
      }
    },
    openEstimationListModal() {},
    openEstimationDetailModal() {},
    openProfileModal() {},
    openQuotation() {},
    reportStore() {
      this.$router.push({
        name: 'chat.report',
        query: {
          id: this.chatroom.id,
          name: this.chatroom.store.name,
        },
      });
    },
    reportUser() {
      var userId = '';
      var userNickName = '';

      if (this.chatroom.chatMembers[0].user.roles === '21') {
        userId = this.chatroom.chatMembers[1].userId;
        userNickName = this.chatroom.chatMembers[1].user.nickname;
      } else {
        userId = this.chatroom.chatMembers[0].userId;
        userNickName = this.chatroom.chatMembers[0].user.nickname;
      }

      this.$router.push({
        name: 'Report.Main',
        query: {
          userId,
          userNickName,
        },
      });
    },
  },
};
